import type { ParticipantEditSubmitAPIResponse } from '../types'

export function participantEditSubmitMapper(data: ParticipantEditSubmitAPIResponse): string | undefined {
  const updatedParticipantId = data?.apiResponse?.updateResult?.participants?.[0]?.participantId

  return updatedParticipantId === undefined ? undefined : String(updatedParticipantId)
}
